module.exports = __webpack_public_path__ + "img/404Mobile.e606f52b.png";